module.exports = __webpack_public_path__ + "static/Shield-5dccd19321495aca43aed33dd99d931c.png";